import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Hero from './Hero';
import NavbarStandard from './NavbarStandard';
import Processes from './Processes';
import Services from './Services';
import AgentSimulator from './AgentSimulator';
import LandingPricing from './LandingPricing';
import LandingBlog from './LandingBlog';
import LandingFaq from './LandingFaq';
import Cta from './Cta';
import FooterStandard from './FooterStandard';

const Landing = () => {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return;
    }

    const id = hash.replace('#', '');
    const rafId = window.requestAnimationFrame(() => {
      const target = document.getElementById(id);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });

    return () => window.cancelAnimationFrame(rafId);
  }, [hash]);

  return (
    <>
      <NavbarStandard />
      <Hero />
      <Services />
      <AgentSimulator />
      <Processes />
      <LandingPricing />
      <LandingFaq />
      <LandingBlog />
      <Cta />
      <FooterStandard />
    </>
  );
};

export default Landing;
